import { useEffect } from 'react'
import { trackEvent } from 'analytics/trackFunctions'
import PageWrapper from 'components/PageWrapper'
import DiscountInfo from 'components/discounts/DiscountInfo'
import { useDiscountStore } from 'store/discounts'

const Discount = () => {
  const { selectedDiscount } = useDiscountStore((state) => ({
    selectedDiscount: state.selectedDiscount
  }))

  useEffect(() => {
    trackEvent({ eventName: 'bille_pantalla_descuento' })
  }, [])

  return (
    <PageWrapper noTabBar title='Detalles del beneficio'>
      <DiscountInfo
        category={selectedDiscount?.category}
        bgImage={selectedDiscount?.image_url}
        emoji={selectedDiscount?.icon_image_url}
        description={selectedDiscount?.description}
        duration={selectedDiscount?.validity}
        limit={selectedDiscount?.cashback_limit}
        frequency={selectedDiscount?.days}
        discount={selectedDiscount?.title_long}
        paymentMethods={{
          wayni: selectedDiscount?.payment_method_wayni,
          mastercard: selectedDiscount?.payment_method_mastercard,
          gpay: selectedDiscount?.payment_method_gpay
        }}
        paymentMethodDescription={selectedDiscount?.paymen_method_description}
        termsUrl={selectedDiscount?.terms_url}
      />
    </PageWrapper>
  )
}

export default Discount
